import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import Button from '@shared/ui/button'
import Input from '@shared/ui/input'
import { formatPrice } from '@shared/uttils'

import { usePromocodeManager } from '../lib/usePromocodeManager'

import styles from './styles.module.scss'

export default function PromocodeApplier () {
  const { t } = useTranslation('cart')
  const { t: tc } = useTranslation('common')
  const {
    appliedPromocode,
    isApplied,
    saleAmount,
    isProcessing,
    applyPromocode,
    clearPromocode,
  } = usePromocodeManager()

  const [ promoCode, setPromoCode ] = useState('')
  const [ error, setError ] = useState('')

  useEffect(() => {
    if (isApplied) {
      setPromoCode(appliedPromocode)
      setError('')
    }
  }, [ appliedPromocode, isApplied ])

  const handleApply = async () => {
    try {
      setError('')
      await applyPromocode(promoCode)
    }
    catch (applyError) {
      setError(
        applyError instanceof Error
          ? applyError.message
          : t('discount.apply_error'),
      )
    }
  }

  const handleClear = async () => {
    try {
      setError('')
      await clearPromocode()
      setPromoCode('')
    }
    catch (clearError) {
      setError(
        clearError instanceof Error
          ? clearError.message
          : t('discount.clear_error'),
      )
    }
  }

  return (
    <div className={styles.promo}>
      <div className={styles.promo__input}>
        <Input
          value={promoCode}
          onChange={(e) => {
            setPromoCode(e.target.value.toUpperCase())
            setError('')
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !isApplied && !isProcessing) {
              void handleApply()
            }
          }}
          placeholder={t('discount.enter_promocode')}
          inputSize="large"
          className={styles.promo__field}
          isInvalid={!!error}
          disabled={isApplied || isProcessing}
        />

        {isApplied ? (
          <Button
            className={styles.promo__buttonText}
            theme="secondary"
            onClick={() => void handleClear()}
            disabled={isProcessing}
          >
            {tc('cancel')}
          </Button>
        ) : (
          <Button
            className={styles.promo__button}
            onClick={() => void handleApply()}
            disabled={isProcessing || !promoCode.trim()}
          >
            <ReactSVG src="/icons/arrow-right.svg" />
          </Button>
        )}
      </div>

      {!!error && (
        <div className={styles.promo__error}>{error}</div>
      )}

      {isApplied && (
        <div className={styles.promo__info}>
          <span className={styles.promo__code}>
            {t('discount.promocodes')}: {appliedPromocode}
          </span>
          {saleAmount > 0 && (
            <span className={styles.promo__sale}>
              {t('total.discount')}: -{formatPrice(saleAmount)}
            </span>
          )}
        </div>
      )}
    </div>
  )
}
